import React, { useState, createContext, useContext } from 'react';
type Language = 'lv' | 'en';
interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string) => string;
}
const translations = {
  lv: {
    // Navbar
    'nav.classes': 'Klases',
    'nav.map': 'Karte',
    'nav.raceInfo': 'Sacensību info',
    'nav.team': 'Komanda',
    'nav.gallery': 'Galerija',
    'nav.register': 'Reģistrēties',
    // Hero
    'hero.poweredBy': 'Powered by Pirmais Racing',
    'hero.tagline': 'Kur izdzīvo tikai stiprākie.',
    'hero.description': 'Pārbaudi savas robežas brutālā apvidū, neiespējamos šķēršļos un nerimstošā sacensībā. Vai esi gatavs sevi pierādīt?',
    'hero.learnMore': 'Uzzināt vairāk',
    // Race Info
    'raceInfo.markCalendar': 'Atzīmē kalendārā',
    'raceInfo.title': 'SACENSĪBU INFORMĀCIJA',
    'raceInfo.startsIn': 'Sacensības sākas pēc',
    'raceInfo.days': 'Dienas',
    'raceInfo.hours': 'Stundas',
    'raceInfo.minutes': 'Minūtes',
    'raceInfo.seconds': 'Sekundes',
    'raceInfo.location': 'Vieta',
    'raceInfo.locationDesc': 'Sacensību vieta atrodas Raunas pagastā. Dabīgais apvidus nodrošina lielisku dabīgo un mākslīgo šķēršļu kombināciju dažādā reljefā.',
    'raceInfo.superEnduro': 'SuperEnduro',
    'raceInfo.hardEnduroRace': 'Hard Enduro Race',
    'raceInfo.registration': 'Reģistrācija',
    'raceInfo.freePractice': 'Brīvie treniņi',
    'raceInfo.qualification': 'Kvalifikācija (Time Practice)',
    'raceInfo.superPole': 'Kvalifikācija priekš superfināla (SuperPole)',
    'raceInfo.superFinal': 'Superfināls',
    'raceInfo.lastChance': '"Last Chance" brauciens',
    'raceInfo.semiFinals': 'Pusfināli',
    'raceInfo.awardCeremony': 'Apbalvošana',
    'raceInfo.technicalInspection': 'Tehniskā kontrole',
    'raceInfo.ridersBriefing': 'Braucēju instruktāža',
    'raceInfo.raceStart': 'Sacensību starts',
    'raceInfo.awardCeremonyFull': 'Apbalvošanas ceremonija',
    'raceInfo.raceFormat': 'Sacensību formāts',
    'raceInfo.formatDesc': 'Pirmā diena būs veltīta SuperEnduro treniņsacensībām! Šīs treniņsacensības nav obligātas un neietekmē HardEnduro galvenā pasākuma rezultātus, taču tās dod lielisku iespēju iesildīties un uzlabot savas prasmes SuperEnduro sekcijā. Gatavojies aizraujošai trasei, lieliskai atmosfērai un daudz jautrības — šī diena būs īsta sagatavošanās nākamajām HardEnduro cīņām! SuperEnduro treniņsacensības ietilpst dalības maksā.',
    'raceInfo.terrain': 'Apvidus',
    'raceInfo.terrainDesc': 'Brutāls dabīgo un mākslīgo šķēršļu sajaukums dažādos apvidus tipos:',
    'raceInfo.sandDunes': 'Smilšu kāpas',
    'raceInfo.rockGarden': 'Akmeņu dārzs',
    'raceInfo.forestTrails': 'Meža takas',
    'raceInfo.drops': 'Drops',
    'raceInfo.mudPits': 'Dubļu bedres',
    'raceInfo.hillClimbs': 'Kalnu kāpumi',
    'raceInfo.logObstacles': 'Baļķu šķēršļi',
    'raceInfo.gravelRoads': 'Grants ceļi',
    'raceInfo.participants': 'Dalībnieki',
    'raceInfo.earlyRegistered': 'Savlaicīgi reģistrējušies dalībnieki:',
    'raceInfo.beginners': 'Iesācēji',
    'raceInfo.hobby': 'Hobby',
    'raceInfo.pro': 'Pro',
    'raceInfo.total': 'Kopā',
    'raceInfo.riders': 'braucēji',
    'raceInfo.friday': '2026. gada 15. maijs (piektdiena)',
    'raceInfo.saturday': '2026. gada 16. maijs (sestdiena)',
    // Racing Classes
    'classes.chooseChallenge': 'Izvēlies savu izaicinājumu',
    'classes.title': 'SACENSĪBU KLASES',
    'classes.subtitle': 'Trīs intensitātes līmeņi. Izvēlies to, kas atbilst tavām prasmēm un drosmei.',
    'classes.beginner': 'IESĀCĒJI',
    'classes.hobby': 'Hobby',
    'classes.pro': 'PRO',
    'classes.beginnerDesc': 'Piemērots kā Tavs pirmais hard enduro piedzīvojums. Maršruts vijas pa karjeru un mežu, izaicinošās un tehniskās vietas būs iespējams apbraukt, lai varētu izbaudīt sacensību garšu bez liekas spriedzes.',
    'classes.hobbyDesc': 'Trase būs manāmi sarežģītāka - dabīgi un mākslīgi veidoti šķēršļi un tehniskas vietas, kas liks pasvīst, taču bez Pro klases galējībām. Galvenais ir piedalīties, uzdrīkstēties un kārtīgi izbaudīt procesu!',
    'classes.proDesc': 'Pro klase – tas ir īstens pārbaudījums spēcīgākajiem! Šeit nebūs nekādu atlaides posmu, tikai tīrs adrenalīns, izcila tehnika un cīņa pašam ar sevi. Parādi savu izturību, meistarību un sasniedz savus mērķus!',
    'classes.requirements': 'Prasības',
    'classes.perRider': '/ dalībnieks',
    'classes.earlyBird': 'Apmaksājot iepriekš — €80',
    'classes.popular': 'Populārs',
    'classes.distance': 'Distance',
    'classes.timeLimit': 'Laika limits',
    'classes.scoringRule': 'Uzvarētāju nosaka pēc sabraukto kontrolpunktu skaita — kurš vairāk, tas augstāk.',
    'classes.beginnerReq1': 'Enduro vai motokrosa motocikls (jebkurš dzinēja tilpums)',
    'classes.beginnerReq2': 'Pilns aizsargekipējums (ķivere, zābaki, aizsargi)',
    'classes.beginnerReq3': 'Iepriekšēja sacensību pieredze nav nepieciešama',
    'classes.beginnerReq4': 'Saīsināta trase — 10 km aplis',
    'classes.hobbyReq1': 'Ieteicams enduro motocikls (250cc+)',
    'classes.hobbyReq2': 'Pilns aizsargekipējums, ieteicams kakla aizsargs',
    'classes.hobbyReq3': 'Vismaz 1 gada bezceļa pieredze',
    'classes.hobbyReq4': 'Pilna trase — 12 km ar tehniskām sekcijām',
    'classes.proReq1': 'Sacensību enduro motocikls (200cc–500cc)',
    'classes.proReq2': 'Pilns sacensību ekipējums ar obligātu kakla aizsargu',
    'classes.proReq3': 'Vismaz 2 gadu sacensību enduro pieredze',
    'classes.proReq4': 'Pagarināta trase — 13 km ar ekstrēmām sekcijām',
    // Competition Map
    'map.knowBattlefield': 'Iepazīsti cīņas lauku',
    'map.title': 'SACENSĪBU KARTE',
    'map.subtitle': 'Izpēti trasi. Iepazīsti šķēršļus. Plāno savu uzbrukumu.',
    'map.legend': 'Kartes leģenda',
    'map.info': 'Informācija',
    'map.about': 'Par',
    'map.crossings': 'Šķērsošļiem',
    'map.nearest': 'Tuvākā',
    'map.time': 'Laikā',
    'map.join': 'Pievienosies',
    'map.difficultyHigh': 'Grūtība: Augsta',
    'map.difficultyMedium': 'Grūtība: Vidēja',
    'map.difficultyExtreme': 'Grūtība: Ekstrēma',
    'map.difficultyLow': 'Grūtība: Zema',
    'map.infoComingSoon': 'Informācija sekos',
    'map.startFinish': 'Starts / Finišs',
    'map.rockGardenTechnical': 'Akmeņu dārzs — Tehnisks',
    'map.riverCrossing': 'Upju šķērsošana — Dziļš ūdens',
    'map.denseForestTrail': 'Biezs meža celiņš',
    'map.verticalClimb': 'Vertikāls kāpums — Tikai Pro',
    'map.checkpoint': 'Kontrolpunkts / Atpūtas zona',
    // Team & Sponsors
    'team.peopleBehind': 'Cilvēki aiz šī trakuma',
    'team.title': 'MŪSU KOMANDA',
    'team.subtitle': 'Aizrautīgi braucēji un organizatori, kas veltīti visbrutālākā hard enduro pasākuma radīšanai Baltijā.',
    'team.makingPossible': 'To iespējamo padara',
    'team.sponsorsTitle': 'MŪSU SPONSORI UN PARTNERI',
    'team.titleSponsor': 'Titulsponsors',
    'team.goldSponsors': 'Zelta sponsori',
    'team.silverSponsors': 'Sudraba sponsori',
    'team.officialSponsor': 'Oficiālais titulsponsors un tehniskais partneris',
    'team.member1Role': 'Radošais eksperts',
    'team.member1Desc': 'Reklāmas un dizaina eksperts, kurš panāk, lai viss izskatās tik labi, ka gribas uzreiz pieteikties. Ja nepiesaista uzmanību — viņš vēl nav pabeidzis.',
    'team.member2Role': 'Trases eksperts',
    'team.member2Desc': 'Tas, kurš no vienkārša ceļa spēj izveidot īstu piedzīvojumu ar līkumiem, pārbaudījumiem un nelielu "kāpēc es te pieteicos?" sajūtu.',
    'team.member3Role': 'Papīru eksperts',
    'team.member3Desc': 'Tas, kurš zina, kur kas jāparaksta, jāaizpilda un jāiesniedz — lai pārējiem par to nebūtu jādomā.',
    'team.member4Role': 'Tehniskā parka eksperts',
    'team.member4Desc': 'Cilvēks, kurš pārvērš tehnisko parku par izaicinājumu, kas spēj pārbaudīt visus nervus — un tomēr liek dalībniekiem smieties un atgriezties.',
    'team.member5Role': 'Dalībnieku eksperts',
    'team.member5Desc': 'Cilvēks, kurš pārvērš ikvienu skatītāju par dalībnieku un pārliecinās, ka neviens nepalaidīs garām piedzīvojumu.',
    'team.member6Role': 'Stiprākais eksperts',
    'team.member6Desc': 'Cilvēks, kurš vienlaikus padomā par detaļām un nekautrējas pacelt, pārvietot vai izdarīt visu, kas nepieciešams.',
    // Contact Form
    'contact.secureSpot': 'Nodrošini savu vietu',
    'contact.title': 'REĢISTRĒTIES TAGAD',
    'contact.subtitle': 'Aizpildi savus datus zemāk. Ierobežots vietu skaits — nepalaid garām.',
    'contact.firstName': 'Vārds',
    'contact.lastName': 'Uzvārds',
    'contact.email': 'E-pasta adrese',
    'contact.phone': 'Telefona numurs',
    'contact.bikeModel': 'Motocikla modelis',
    'contact.engineSize': 'Dzinēja tilpums (cm³)',
    'contact.raceClass': 'Sacensību klase',
    'contact.selectClass': 'Izvēlieties sacensību klasi',
    'contact.licenseNumber': 'Sacensību licences numurs',
    'contact.teamName': 'Komandas nosaukums (neobligāts)',
    'contact.submit': 'Pabeigt reģistrāciju',
    'contact.submitting': 'Apstrādā reģistrāciju...',
    'contact.successTitle': 'REĢISTRĀCIJA PABEIGTA',
    'contact.successMessage': 'Tu esi iekšā! Pārbaudi savu e-pastu, lai saņemtu apstiprinājuma informāciju un sacensību dienas instrukcijas. Tiekamies startā.',
    'contact.registerAnother': 'Reģistrēt vēl vienu braucēju',
    'contact.errorMessage': 'Kaut kas nogāja greizi. Lūdzu, mēģiniet vēlreiz.',
    'contact.disclaimer': 'Reģistrējoties, jūs piekrītat sacensību noteikumiem, drošības regulām un uzņematies visus riskus, kas saistīti ar hard enduro sacensībām. Tāpat Jums tiks nosūtīts atkārtots e-pasts ar rekvizītiem dalības maksas pārskaitīšanai.',
    'contact.optional': '(neobligāts)',
    'contact.required': '*',
    'contact.enterFirstName': 'Ievadiet savu vārdu',
    'contact.enterLastName': 'Ievadiet savu uzvārdu',
    'contact.enterTeamName': 'Ievadiet komandas nosaukumu',
    'contact.beginnerOption': 'Iesācēji',
    'contact.hobbyOption': 'Hobby',
    'contact.proOption': 'Pro',
    'contact.errorFirstName': 'Vārds ir obligāts',
    'contact.errorLastName': 'Uzvārds ir obligāts',
    'contact.errorEmail': 'E-pasts ir obligāts',
    'contact.errorEmailInvalid': 'Lūdzu, ievadiet derīgu e-pasta adresi',
    'contact.errorPhone': 'Telefona numurs ir obligāts',
    'contact.errorPhoneInvalid': 'Lūdzu, ievadiet derīgu telefona numuru',
    'contact.errorBikeModel': 'Motocikla modelis ir obligāts',
    'contact.errorEngineSize': 'Dzinēja tilpums ir obligāts',
    'contact.errorEngineSizeInvalid': 'Lūdzu, ievadiet derīgu dzinēja tilpumu cm³',
    'contact.errorRaceClass': 'Lūdzu, izvēlieties sacensību klasi',
    'contact.errorLicense': 'Sacensību licence ir obligāta Pro klasei',
    // Photo Gallery
    'gallery.reliveAction': 'Izdzīvo darbību vēlreiz',
    'gallery.title': 'FOTO GALERIJA',
    'gallery.subtitle': 'Iepriekšējo gadu spilgtākie mirkļi. Dubļi, neatlaidība un slava.',
    'gallery.photos2025': '2025. gada bildes',
    'gallery.photos2024': '2024. gada bildes',
    // Footer
    'footer.description': 'Brutālākās hard enduro sacensības Baltijā. Powered by Pirmais Racing.',
    'footer.tagline': 'Kur izdzīvo tikai stiprākie.',
    'footer.quickLinks': 'Ātrās saites',
    'footer.racingClasses': 'Sacensību klases',
    'footer.competitionMap': 'Sacensību karte',
    'footer.raceInfo': 'Sacensību informācija',
    'footer.registration': 'Reģistrācija',
    'footer.photoGallery': 'Foto galerija',
    'footer.contact': 'Kontakti',
    'footer.copyright': '© 2026 Motomaniac Hard Enduro Race. Visas tiesības aizsargātas. Powered by Pirmais Racing.',
    'footer.privacyPolicy': 'Privātuma politika',
    'footer.termsConditions': 'Noteikumi un nosacījumi',
    'footer.raceRules': 'Sacensību noteikumi',
    // App
    'app.title': 'Motomaniac Hard Enduro Race'
  },
  en: {
    // Navbar
    'nav.classes': 'Classes',
    'nav.map': 'Map',
    'nav.raceInfo': 'Race Info',
    'nav.team': 'Team',
    'nav.gallery': 'Gallery',
    'nav.register': 'Register',
    // Hero
    'hero.poweredBy': 'Powered by Pirmais Racing',
    'hero.tagline': 'Where only the toughest survive.',
    'hero.description': 'Push your limits on brutal terrain, impossible obstacles, and relentless competition. Are you ready to prove yourself?',
    'hero.learnMore': 'Learn More',
    // Race Info
    'raceInfo.markCalendar': 'Mark Your Calendar',
    'raceInfo.title': 'RACE INFORMATION',
    'raceInfo.startsIn': 'Race starts in',
    'raceInfo.days': 'Days',
    'raceInfo.hours': 'Hours',
    'raceInfo.minutes': 'Minutes',
    'raceInfo.seconds': 'Seconds',
    'raceInfo.location': 'Location',
    'raceInfo.locationDesc': 'The competition venue is located in Rauna parish. The natural terrain provides an excellent combination of natural and artificial obstacles across varied relief.',
    'raceInfo.superEnduro': 'SuperEnduro',
    'raceInfo.hardEnduroRace': 'Hard Enduro Race',
    'raceInfo.registration': 'Registration',
    'raceInfo.freePractice': 'Free Practice',
    'raceInfo.qualification': 'Qualification (Time Practice)',
    'raceInfo.superPole': 'SuperPole Qualification',
    'raceInfo.superFinal': 'Super Final',
    'raceInfo.lastChance': '"Last Chance" Race',
    'raceInfo.semiFinals': 'Semi-Finals',
    'raceInfo.awardCeremony': 'Award Ceremony',
    'raceInfo.technicalInspection': 'Technical Inspection',
    'raceInfo.ridersBriefing': 'Riders Briefing',
    'raceInfo.raceStart': 'Race Start',
    'raceInfo.awardCeremonyFull': 'Award Ceremony',
    'raceInfo.raceFormat': 'Race Format',
    'raceInfo.formatDesc': 'The first day will be dedicated to SuperEnduro training races! These training races are not mandatory and do not affect the main HardEnduro event results, but they provide an excellent opportunity to warm up and improve your skills in the SuperEnduro section. Get ready for an exciting track, great atmosphere, and lots of fun — this day will be a true preparation for the upcoming HardEnduro battles! SuperEnduro training races are included in the entry fee.',
    'raceInfo.terrain': 'Terrain',
    'raceInfo.terrainDesc': 'A brutal mix of natural and artificial obstacles across various terrain types:',
    'raceInfo.sandDunes': 'Sand Dunes',
    'raceInfo.rockGarden': 'Rock Garden',
    'raceInfo.forestTrails': 'Forest Trails',
    'raceInfo.drops': 'Drops',
    'raceInfo.mudPits': 'Mud Pits',
    'raceInfo.hillClimbs': 'Hill Climbs',
    'raceInfo.logObstacles': 'Log Obstacles',
    'raceInfo.gravelRoads': 'Gravel Roads',
    'raceInfo.participants': 'Participants',
    'raceInfo.earlyRegistered': 'Early registered participants:',
    'raceInfo.beginners': 'Beginners',
    'raceInfo.hobby': 'Hobby',
    'raceInfo.pro': 'Pro',
    'raceInfo.total': 'Total',
    'raceInfo.riders': 'riders',
    'raceInfo.friday': 'May 15, 2026 (Friday)',
    'raceInfo.saturday': 'May 16, 2026 (Saturday)',
    // Racing Classes
    'classes.chooseChallenge': 'Choose Your Challenge',
    'classes.title': 'RACING CLASSES',
    'classes.subtitle': 'Three intensity levels. Choose the one that matches your skill and courage.',
    'classes.beginner': 'BEGINNER',
    'classes.hobby': 'HOBBY',
    'classes.pro': 'PRO',
    'classes.beginnerDesc': 'Perfect as your first hard enduro adventure. The route winds through quarry and forest, with challenging and technical sections that can be bypassed to enjoy the race experience without excessive stress.',
    'classes.hobbyDesc': 'The track will be noticeably more challenging - natural and artificial obstacles and technical sections that will make you sweat, but without the extremes of the Pro class. The main thing is to participate, dare, and thoroughly enjoy the process!',
    'classes.proDesc': 'Pro class – this is a true test for the strongest! There will be no relief sections here, only pure adrenaline, excellent technique, and a battle with yourself. Show your endurance, mastery, and achieve your goals!',
    'classes.requirements': 'Requirements',
    'classes.perRider': '/ rider',
    'classes.earlyBird': 'Pay in advance — €80',
    'classes.popular': 'Popular',
    'classes.distance': 'Distance',
    'classes.timeLimit': 'Time Limit',
    'classes.scoringRule': 'The winner is determined by the most checkpoints completed — more checkpoints, higher placement.',
    'classes.beginnerReq1': 'Enduro or motocross motorcycle (any engine size)',
    'classes.beginnerReq2': 'Full protective gear (helmet, boots, guards)',
    'classes.beginnerReq3': 'No previous racing experience required',
    'classes.beginnerReq4': 'Shortened track — 10 km loop',
    'classes.hobbyReq1': 'Enduro motorcycle recommended (250cc+)',
    'classes.hobbyReq2': 'Full protective gear, neck brace recommended',
    'classes.hobbyReq3': 'At least 1 year off-road experience',
    'classes.hobbyReq4': 'Full track — 12 km with technical sections',
    'classes.proReq1': 'Competition enduro motorcycle (200cc–500cc)',
    'classes.proReq2': 'Full racing gear with mandatory neck brace',
    'classes.proReq3': 'At least 2 years competition enduro experience',
    'classes.proReq4': 'Extended track — 13 km with extreme sections',
    // Competition Map
    'map.knowBattlefield': 'Know Your Battlefield',
    'map.title': 'COMPETITION MAP',
    'map.subtitle': 'Explore the track. Study the obstacles. Plan your attack.',
    'map.legend': 'Map Legend',
    'map.info': 'Info',
    'map.about': 'About',
    'map.crossings': 'Crossings',
    'map.nearest': 'Nearest',
    'map.time': 'Time',
    'map.join': 'Join',
    'map.difficultyHigh': 'Difficulty: High',
    'map.difficultyMedium': 'Difficulty: Medium',
    'map.difficultyExtreme': 'Difficulty: Extreme',
    'map.difficultyLow': 'Difficulty: Low',
    'map.infoComingSoon': 'Information coming soon',
    'map.startFinish': 'Start / Finish',
    'map.rockGardenTechnical': 'Rock Garden — Technical',
    'map.riverCrossing': 'River Crossing — Deep Water',
    'map.denseForestTrail': 'Dense Forest Trail',
    'map.verticalClimb': 'Vertical Climb — Pro Only',
    'map.checkpoint': 'Checkpoint / Rest Zone',
    // Team & Sponsors
    'team.peopleBehind': 'The People Behind This Madness',
    'team.title': 'OUR TEAM',
    'team.subtitle': 'Passionate riders and organizers dedicated to creating the most brutal hard enduro event in the Baltics.',
    'team.makingPossible': 'Making It Possible',
    'team.sponsorsTitle': 'OUR SPONSORS AND PARTNERS',
    'team.titleSponsor': 'Title Sponsor',
    'team.goldSponsors': 'Gold Sponsors',
    'team.silverSponsors': 'Silver Sponsors',
    'team.officialSponsor': 'Official title sponsor and technical partner',
    'team.member1Role': 'Creative Expert',
    'team.member1Desc': "Advertising and design expert who makes everything look so good you want to sign up immediately. If it doesn't grab attention — he's not done yet.",
    'team.member2Role': 'Track Expert',
    'team.member2Desc': 'The one who can turn a simple road into a real adventure with twists, challenges, and a little "why did I sign up for this?" feeling.',
    'team.member3Role': 'Paperwork Expert',
    'team.member3Desc': "The one who knows where to sign, fill in, and submit — so others don't have to think about it.",
    'team.member4Role': 'Technical Park Expert',
    'team.member4Desc': 'The person who transforms the technical park into a challenge that can test all nerves — yet makes participants laugh and come back.',
    'team.member5Role': 'Participant Expert',
    'team.member5Desc': 'The person who turns every spectator into a participant and makes sure no one misses the adventure.',
    'team.member6Role': 'Strongest Expert',
    'team.member6Desc': 'The person who thinks about details while not hesitating to lift, move, or do whatever is needed.',
    // Contact Form
    'contact.secureSpot': 'Secure Your Spot',
    'contact.title': 'REGISTER NOW',
    'contact.subtitle': "Fill in your details below. Limited spots — don't miss out.",
    'contact.firstName': 'First Name',
    'contact.lastName': 'Last Name',
    'contact.email': 'Email Address',
    'contact.phone': 'Phone Number',
    'contact.bikeModel': 'Motorcycle Model',
    'contact.engineSize': 'Engine Size (cc)',
    'contact.raceClass': 'Race Class',
    'contact.selectClass': 'Select race class',
    'contact.licenseNumber': 'Racing License Number',
    'contact.teamName': 'Team Name (optional)',
    'contact.submit': 'Complete Registration',
    'contact.submitting': 'Processing registration...',
    'contact.successTitle': 'REGISTRATION COMPLETE',
    'contact.successMessage': "You're in! Check your email for confirmation information and race day instructions. See you at the start.",
    'contact.registerAnother': 'Register Another Rider',
    'contact.errorMessage': 'Something went wrong. Please try again.',
    'contact.disclaimer': 'By registering, you agree to the competition rules, safety regulations, and assume all risks associated with hard enduro racing. You will also receive a follow-up email with payment details for the entry fee.',
    'contact.optional': '(optional)',
    'contact.required': '*',
    'contact.enterFirstName': 'Enter your first name',
    'contact.enterLastName': 'Enter your last name',
    'contact.enterTeamName': 'Enter team name',
    'contact.beginnerOption': 'Beginners',
    'contact.hobbyOption': 'Hobby',
    'contact.proOption': 'Pro',
    'contact.errorFirstName': 'First name is required',
    'contact.errorLastName': 'Last name is required',
    'contact.errorEmail': 'Email is required',
    'contact.errorEmailInvalid': 'Please enter a valid email address',
    'contact.errorPhone': 'Phone number is required',
    'contact.errorPhoneInvalid': 'Please enter a valid phone number',
    'contact.errorBikeModel': 'Motorcycle model is required',
    'contact.errorEngineSize': 'Engine size is required',
    'contact.errorEngineSizeInvalid': 'Please enter a valid engine size in cc',
    'contact.errorRaceClass': 'Please select a race class',
    'contact.errorLicense': 'Racing license is required for Pro class',
    // Photo Gallery
    'gallery.reliveAction': 'Relive The Action',
    'gallery.title': 'PHOTO GALLERY',
    'gallery.subtitle': 'Highlights from previous years. Mud, perseverance, and glory.',
    'gallery.photos2025': '2025 Photos',
    'gallery.photos2024': '2024 Photos',
    // Footer
    'footer.description': 'The most brutal hard enduro race in the Baltics. Powered by Pirmais Racing.',
    'footer.tagline': 'Where only the toughest survive.',
    'footer.quickLinks': 'Quick Links',
    'footer.racingClasses': 'Racing Classes',
    'footer.competitionMap': 'Competition Map',
    'footer.raceInfo': 'Race Information',
    'footer.registration': 'Registration',
    'footer.photoGallery': 'Photo Gallery',
    'footer.contact': 'Contact',
    'footer.copyright': '© 2026 Motomaniac Hard Enduro Race. All rights reserved. Powered by Pirmais Racing.',
    'footer.privacyPolicy': 'Privacy Policy',
    'footer.termsConditions': 'Terms and Conditions',
    'footer.raceRules': 'Race Rules',
    // App
    'app.title': 'Motomaniac Hard Enduro Race'
  }
};
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
interface LanguageProviderProps {
  children: ReactNode;
}
export function LanguageProvider({
  children
}: LanguageProviderProps) {
  const [language, setLanguage] = useState<Language>('lv');
  const t = (key: string): string => {
    const dict = translations[language];
    return dict[key as keyof typeof dict] || key;
  };
  return <LanguageContext.Provider value={{
    language,
    setLanguage,
    t
  }} data-id="element-788">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage(): LanguageContextType {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}